import React from "react";
import "./TermsDescriptions.css"; // optional if you want external styling

const TermsDescriptions = () => {
  return (
    <div className="terms-container">
      <h1>BeyondSchools Academy Limited – Terms and Conditions</h1>
      <p className="updated">Last Updated: November 2025</p>

      <p>
        These Terms of Service (“Terms”) govern your access and use of the BeyondSchools
        learning platform, including our website, mobile applications, and related
        services provided by BeyondSchools Academy Limited (“we,” “our,” or “us”).
        By creating an account or using our services, you agree to be bound by these Terms.
        If you do not agree, do not use the BeyondSchools platform.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By registering or using BeyondSchools, you accept these Terms, agree to comply
        with relevant laws, and acknowledge that BeyondSchools may update these Terms
        when necessary. Changes will be communicated through the app or website.
      </p>

      <h2>2. What We Provide</h2>
      <p>
        BeyondSchools offers an online learning environment for students, parents,
        teachers, and institutions. Our services include course creation, video lessons,
        learning dashboards, course marketplace, discussions, communication tools,
        notifications, and secure payments.
      </p>

      <h2>3. Eligibility (Minimum Age Requirement)</h2>
      <p>
        You must be at least 12 years old to use BeyondSchools independently.
        Users under 18 must have parental consent. Parents are responsible for monitoring usage.
      </p>

      <h2>4. Account Registration</h2>
      <p>
        Users must provide accurate information, use real names, keep login details secure,
        and notify us if unauthorized access is suspected. You are responsible for all
        activity under your account.
      </p>

      <h2>5. Account Sharing</h2>
      <p>
        Sharing accounts is not allowed. One account = one user.
        Violations result in:
      </p>
      <ul>
        <li>Warning 1 – notification and temporary lock</li>
        <li>Warning 2 – longer suspension</li>
        <li>Final Step – termination</li>
      </ul>
      <p>
        We use a soft, educational approach to help users understand safe usage.
      </p>

      <h2>6. Subscriptions</h2>
      <p>
        Payments are securely processed through Selcom, supporting mobile and bank payments.
        All transactions are encrypted through Selcom’s secure gateway.
      </p>
      <p>
        All subscriptions are valid for a period of one (1) year from the date of purchase.
        After the one-year period, the subscription will automatically expire, and access to subscription-based content or features will be restricted unless renewed.
      </p>
      <p>
        Users are responsible for renewing their subscriptions before expiration to maintain uninterrupted access.
      </p>


      <h2>7. No Refund Policy</h2>
      <p>
        BeyondSchools does not offer refunds once payment is completed and digital content
        is unlocked. Exceptions apply only when required by Tanzanian law.
      </p>

      <h2>8. User Responsibilities</h2>
      <p>You agree NOT to:</p>
      <ul>
        <li>Post harmful or abusive content</li>
        <li>Interfere with others' learning experience</li>
        <li>Hack or attempt to disrupt systems</li>
        <li>Upload illegal or copyrighted content</li>
        <li>Create multiple fake accounts</li>
      </ul>
      <p>
        Violations may lead to suspension or permanent termination.
      </p>

      <h2>9. Teacher Content & Responsibilities</h2>
      <p>
        Teachers must upload original educational content, respect guidelines, keep
        student data private, and communicate professionally. BeyondSchools may remove
        content that violates rules or laws.
      </p>

      <h2>10. Intellectual Property</h2>
      <p>
        All platform material (videos, graphics, UI, logos) is owned by BeyondSchools
        Academy Limited. Users may not copy or distribute content without permission.
        Teacher-uploaded content remains the teacher’s intellectual property unless
        stated otherwise.
      </p>

      <h2>11. Platform Availability</h2>
      <p>
        We strive for continuous availability but may experience maintenance or
        network interruptions. We do not guarantee uninterrupted service.
      </p>

      <h2>12. Safety and Security</h2>
      <p>
        BeyondSchools uses verification, encrypted systems, and activity monitoring.
        Parents should monitor minors for added safety.
      </p>

      <h2>13. Termination of Account</h2>
      <p>
        We may suspend or terminate accounts involved in fraud, violations, or illegal
        activities. Users may delete their accounts at any time.
      </p>

      <h2>14. Privacy Policy</h2>
      <p>
        By using the platform, you agree to our Privacy Policy, which outlines how we
        collect, store, and use data. We do not sell personal data to third parties.
      </p>

      <h2>15. Contact Information</h2>
      <p>
        Email: support@beyondschools.co.tz<br />
        Website: www.beyondschools.co.tz<br />
        In-app support system
      </p>

      <h2>16. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the United Republic of Tanzania.
        Disputes are resolved by Tanzanian courts.
      </p>

      <h2>17. Agreement</h2>
      <p>
        By creating an account, you confirm that you have read, understood, and agreed
        to these Terms. If you do not agree, discontinue using BeyondSchools.
      </p>
    </div>
  );
};

export default TermsDescriptions;
